import { render, staticRenderFns } from "./InnerFenceAlarmModal.vue?vue&type=template&id=13871b34&scoped=true&"
import script from "./InnerFenceAlarmModal.vue?vue&type=script&lang=js&"
export * from "./InnerFenceAlarmModal.vue?vue&type=script&lang=js&"
import style0 from "./InnerFenceAlarmModal.vue?vue&type=style&index=0&id=13871b34&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13871b34",
  null
  
)

component.options.__file = "InnerFenceAlarmModal.vue"
export default component.exports